module.exports = __webpack_public_path__ + "static/media/creativity2.437929f6.png";